<div class="flex flex-col items-center mobi-ui-padding-x-xl mobi-ui-padding-y-sm">
  @if (icon()) {
    <mobi-ui-icon-major [name]="icon()!" />
  }
  @if (title()) {
    <h5
      class="mobi-ui-font-bold mobi-ui-font-size-50 mobi-ui-font-realist whitespace-nowrap mobi-ui-text-center"
    >
      {{ title() }}
    </h5>
  }
  @if (content()) {
    <span class="mobi-ui-text-center">{{ content() }}</span>
  }
</div>
